import React, { useEffect, useState } from 'react';
import styles from './NewsPage.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import LoaderButton from '../../Molecules/Loader/LoaderButton';
import NewsTopHeader from '../../Molecules/TableTopHeader/NewsTopHeader';
import { useFetchEvents } from '../../../Hooks/News';
import EventCard from '../../Molecules/NewsAndEvents/EventCard';
import TablePagination from '../../Molecules/Pagination/TablePagination';
import EventsActivityHeader from '../../Molecules/NewsAndEvents/EventsActivityHeader';
import { useFetchEventCountdown } from '../../../Hooks/Events';
import EventCoutdownCard from '../../Molecules/NewsAndEvents/EventCountdownCard';
import { debounce, isEmpty } from 'lodash';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';
import Loader from '../../Molecules/Loader/Loader';

const EventsPage = () => {
  const navigate = useNavigate();
  const { eventType } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [search, setSearch] = useState('');

  const {
    data: events,
    refetch: refetchEvents,
    isLoading,
  } = useFetchEvents({
    pageSize: pageSize,
    pageNumber: page,
    year: '',
    selectedActivity: selectedActivity,
    searchKey: search,
  });

  const {
    data: eventsCountdown,
    refetch: refetchEventsCountdown,
    isLoading: isLoadingEventsCountdown,
  } = useFetchEventCountdown(search);

  const itemsPerPage = events?.data?.pageSize;
  const totalItems = events?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleNavigate = (e) => {
    e.preventDefault();
    if ('event-countdown' === eventType) {
      navigate('/home/add-event-countdown');
      return;
    }
    navigate('/home/add-events');
  };

  useEffect(() => {
    refetchEvents();
  }, [page, pageSize, selectedActivity]);

  useEffect(() => {
    if (!isEmpty(search)) {
      handleSearch();
    }
  }, [search]);

  const handleSearch = debounce(() => {
    if ('event-countdown' === eventType) {
      refetchEventsCountdown();
    }
    if ('event' === eventType) {
      refetchEvents();
    }
  }, 300);

  useEffect(() => {
    if ('event-countdown' === eventType) {
      refetchEventsCountdown();
      return;
    }
    refetchEvents();
  }, [eventType]);

  return (
    <div>
      <NewsTopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        type={'event' === eventType ? 'event' : 'event-countdown'}
      />
      <EventsActivityHeader
        selectedActivity={selectedActivity}
        setSelectedActivity={setSelectedActivity}
        eventType={eventType}
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {eventType === 'event' ? (
              events?.data?.items.length > 0 ? (
                <div
                  className={`${styles['major-box-grid']} ${
                    events?.data?.items?.length < 3
                      ? styles['smaller-grid']
                      : ''
                  }`}
                >
                  {events?.data?.items.map((event, index) => (
                    <EventCard
                      key={index}
                      event={event}
                      refetchEvents={refetchEvents}
                    />
                  ))}
                </div>
              ) : (
                <NoDataComponent />
              )
            ) : eventsCountdown?.data?.length > 0 ? (
              <div className={styles['major-box-grid']}>
                {eventsCountdown?.data?.map((event, index) => (
                  <EventCoutdownCard
                    key={index}
                    event={event}
                    refetchEvents={refetchEventsCountdown}
                  />
                ))}
              </div>
            ) : (
              <NoDataComponent />
            )}
          </>
        )}
        {'event' === eventType && (
          <TablePagination
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            itemsPerPage={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </div>
    </div>
  );
};

export default EventsPage;
